import { useContext } from 'react'
import { observer } from 'mobx-react'
import { Header, Icon } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import type { LabelMap } from '@/types/dataCollection'
import { resolveLabel, toIconType } from './helpers'

interface ScreenHeaderProps {
  title: LabelMap
  description?: LabelMap
  /** Icon identifier from the screen config; unknown identifiers render nothing. */
  icon?: string
}

export const ScreenHeader = observer(({ title, description, icon }: ScreenHeaderProps) => {
  const { language } = useContext(StoreContext).TranslationsState
  const iconType = toIconType(icon)

  return (
    <>
      {iconType && (
        <div className="data-collection__screen-icon">
          <Icon type={iconType} size="48px" />
        </div>
      )}
      <Header className="data-collection__screen-title">{resolveLabel(title, language)}</Header>
      {description && (
        <p className="generic__paragraph generic__paragraph-centered">
          {resolveLabel(description, language)}
        </p>
      )}
    </>
  )
})
